import Slider from '../components/Slider';

export default function Home() {
  return (
    <>
      <Slider />
      {/* Add more sections here */}
    </>
  );
}
